import TeamDetailBadge from '@/screens/TeamDetailBadge';

export default function PrivateTabsTeamMainBadgesRoute() {
  return <TeamDetailBadge />;
}
